import React from "react";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Switch } from "@/components/ui/switch";
import { Button } from "@/components/ui/button";
import { Plus, Trash2 } from "lucide-react";
import { SectionHeader, Panel } from "@/components/admin/common";

export default function AdminHours({ value, onChange, onSave, saving }) {
  const rows = value || [];

  const update = (idx, patch) =>
    onChange(rows.map((r, i) => (i === idx ? { ...r, ...patch } : r)));
  const add = () => onChange([...rows, { day: "New day", time: "12:00 – 22:00", closed: false }]);
  const remove = (idx) => {
    if (!window.confirm("Remove this row?")) return;
    onChange(rows.filter((_, i) => i !== idx));
  };

  return (
    <div>
      <SectionHeader
        title="Opening hours"
        description="Edit the hours shown in the Contact section."
        onSave={() => onSave(rows)}
        saving={saving}
      />
      <Panel>
        <div className="space-y-3">
          {rows.map((row, idx) => (
            <div
              key={idx}
              data-testid={`admin-hours-row-${idx}`}
              className="grid grid-cols-1 md:grid-cols-12 gap-3 items-end"
            >
              <div className="md:col-span-4">
                <Label>Day / range</Label>
                <Input
                  value={row.day}
                  onChange={(e) => update(idx, { day: e.target.value })}
                  className="h-11 rounded-xl mt-1"
                />
              </div>
              <div className="md:col-span-5">
                <Label>Time</Label>
                <Input
                  value={row.time}
                  onChange={(e) => update(idx, { time: e.target.value })}
                  placeholder="12:00 – 22:00"
                  className="h-11 rounded-xl mt-1"
                />
              </div>
              <div className="md:col-span-2 flex items-center gap-2 h-11">
                <Switch
                  checked={!!row.closed}
                  onCheckedChange={(v) => update(idx, { closed: v })}
                  data-testid={`admin-hours-closed-${idx}`}
                />
                <span className="text-sm">Closed</span>
              </div>
              <div className="md:col-span-1 flex justify-end">
                <button
                  type="button"
                  onClick={() => remove(idx)}
                  aria-label="Remove row"
                  className="h-10 w-10 rounded-full text-[#E53935] hover:bg-[#E53935]/10 grid place-items-center"
                >
                  <Trash2 className="h-4 w-4" />
                </button>
              </div>
            </div>
          ))}
        </div>
        <div className="mt-6">
          <Button
            type="button"
            onClick={add}
            variant="outline"
            data-testid="admin-add-hours"
            className="rounded-full h-11 border-dashed"
          >
            <Plus className="h-4 w-4 mr-2" /> Add row
          </Button>
        </div>
      </Panel>
    </div>
  );
}
